<template>
  <section class="criar-pedido">
    <div class="container custom-container">
      <HeliarNav />
      <div class="progress criar-pedido--progresso">
        <div
          class="progress-bar"
          role="progressbar"
          :style="{ width: progressWidth }"
        ></div>
        <div class="progresso--itens">
          <p
            class="progresso--item"
            :class="{ 'progresso--item__active': etapa == 1 }"
          >
            Dados pessoais
          </p>
          <p
            class="progresso--item"
            :class="{ 'progresso--item__active': etapa == 2 }"
          >
            Entrega
          </p>
          <p
            class="progresso--item"
            :class="{ 'progresso--item__active': etapa == 3 }"
          >
            Pagamento
          </p>
          <p
            class="progresso--item"
            :class="{ 'progresso--item__active': etapa == 4 }"
          >
            Revisão
          </p>
        </div>
      </div>
      <form class="criar-pedido--form">
        <div class="form--etapa" v-if="etapa == 1">
          <div class="form--col">
            <p class="etapa--title">
              Modelo da bateria
            </p>
            <p class="form--cidade-carro">
              Cidade {{ cidade }} > Carro
              {{ carro }}
            </p>
            <div
              class="form--bateria"
              v-for="(item, index) in baterias"
              :key="index"
              @click="selectBateria(item)"
            >
              <figure class="bateria--img">
                <!-- <img src="../assets/bateria-placeholder.png" alt="" /> -->
                <img
                  :src="urlBaterias + item.Codigo + '/' + item.Arquivo"
                  alt=""
                />
              </figure>
              <div>
                <p class="bateria--modelo">
                  {{ item.Nome.replace(item.CodigoHeliar, "") }}
                  <strong>{{ item.CodigoHeliar }}</strong>
                </p>
                <p class="bateria--preco">
                  <span class="bateria--preco__avista">R$ {{ item.Valor }}</span
                  ><span class="bateria--preco__aprazo">
                    ou até <strong>{{ parcelasDisponiveis }}x sem juros</strong> de
                    <strong>R${{ valorParcelado[index] }}</strong></span
                  >
                </p>
              </div>
              <input
                type="radio"
                class="bateria--select"
                name="bateria"
                :checked="bateriaSelecionada.Codigo === item.Codigo"
              />
            </div>
            <p class="form--divider"><span>OU escolha outro modelo</span></p>
            <div class="form--citycar-selection">
              <div class="citycar-selection--input">
                <span class="icon icon-location citycar-selection--img"></span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Cidade"
                  @input="cidadeSelect = $event.target.value.trim()"
                  v-bind:value="cidadeSelect"
                  autocomplete="off"
                />
              </div>
              <div
                class="citycar-selection--sugestions citycar-selection--sugestions__city"
                v-if="
                  this.sugestCity.length != 0 ||
                    (this.sugestCity.length == 0 &&
                      this.cidadeSelect.length >= 3 &&
                      !validaCidade() &&
                      this.cidades.length > 0)
                "
              >
                <div
                  class="citycar-selection--sugestion"
                  v-for="(item, index) in sugestCity"
                  :key="index"
                  @click="selectCity(item)"
                >
                  <img
                    src="../assets/location-search-icon.png"
                    alt=""
                    class="citycar-selection--img"
                  />
                  <span>{{ item.label }}</span>
                </div>
                <div
                  class="citycar-selection--warn"
                  v-if="
                    this.sugestCity.length == 0 &&
                      this.cidadeSelect.length >= 3 &&
                      !validaCidade()
                  "
                >
                  <p>
                    Infelizmente o Heliar Express não se encontra disponível na
                    sua cidade.
                  </p>
                </div>
              </div>
            </div>
            <div class="form--citycar-selection">
              <div class="citycar-selection--input">
                <span class="icon icon-car citycar-selection--img"></span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Modelo do carro"
                  @input="carroSelect = $event.target.value.trim()"
                  v-bind:value="carroSelect"
                  @blur="toggleInsertCar()"
                  @focus="toggleInsertCar()"
                  autocomplete="off"
                />
              </div>
              <div
                class="citycar-selection--sugestions citycar-selection--sugestions__car"
                v-if="this.sugestCar.length != 0 && this.insertCar"
              >
                <!-- <div class="sugestion-wrapper sugestion-wrapper__carro"> -->
                <div
                  class="citycar-selection--sugestion citycar-selection--sugestion__car"
                  v-for="(item, index) in sugestCar"
                  :key="index"
                  @click="selectCar(item)"
                >
                  <img
                    :src="urlMarcas + item.codigo + '/' + item.arquivo"
                    alt=""
                    class="citycar-selection--img"
                  />
                  <span>{{ item.modelo }}</span>
                  <p>{{ item.ano }}</p>
                </div>
              </div>
            </div>
            <button
              class="btn form--search"
              @click="
                (e) => {
                  e.preventDefault();
                  searchCarCity();
                }
              "
            >
              Buscar
            </button>
          </div>
          <div class="form--col">
            <p class="etapa--title">
              Dados Pessoais
            </p>
            <div class="form-group">
              <label for="nome"
                >Nome Completo<span class="asterisco">*</span></label
              >
              <input
                id="nome"
                type="text"
                v-model.trim="nome"
                class="form-control"
                maxlength="250"
                :class="{
                  'is-invalid': this.validation.hasOwnProperty('nome'),
                }"
                @blur="isValid('nome')"
              />
              <span
                class="invalid-feedback"
                v-if="this.validation.hasOwnProperty('nome')"
                >{{ this.validation["nome"].mensagem }}</span
              >
            </div>
            <div class="form-group">
              <label for="cpf">CPF<span class="asterisco">*</span></label>
              <vue-mask
                :key="keyCpf"
                mask="000.000.000-00"
                :raw="false"
                v-model.trim="cpf"
                type="text"
                class="form-control"
                inputmode="numeric"
                :class="{
                  'is-invalid': this.validation.hasOwnProperty('cpf'),
                }"
                id="cpf"
                @blur="
                  () => {
                    timedOutIsValid('cpf');
                  }
                "
              ></vue-mask>
              <span
                class="invalid-feedback"
                v-if="this.validation.hasOwnProperty('cpf')"
                >{{ this.validation["cpf"].mensagem }}</span
              >
            </div>
            <div class="form-group">
              <label for="telefone"
                >Celular (com DDD)<span class="asterisco">*</span></label
              >
              <vue-mask
                :key="keyTelefone"
                mask="(00) 00000-0000"
                :raw="false"
                id="telefone"
                type="text"
                v-model.trim="tel"
                class="form-control"
                inputmode="numeric"
                :class="{
                  'is-invalid': this.validation.hasOwnProperty('tel'),
                }"
                @blur="timedOutIsValid('tel')"
              ></vue-mask>
              <span
                class="invalid-feedback"
                v-if="this.validation.hasOwnProperty('tel')"
                >{{ this.validation["tel"].mensagem }}</span
              >
            </div>
            <div class="form-group">
              <label for="email">E-mail<span class="asterisco">*</span></label>
              <input
                type="email"
                class="form-control"
                :class="{
                  'is-invalid': this.validation.hasOwnProperty('email'),
                }"
                id="email"
                maxlength="250"
                v-model.trim="email"
                @blur="isValid('email')"
              />
              <span
                class="invalid-feedback"
                v-if="this.validation.hasOwnProperty('email')"
                >{{ this.validation["email"].mensagem }}</span
              >
            </div>
          </div>
        </div>
        <div class="form--etapa" v-if="etapa == 2">
          <div class="form--col">
            <p class="etapa--title">
              Local da entrega
            </p>
            <div class="form--inline-wrapper">
              <div class="form-group form-inline-50">
                <label for="cep">CEP<span class="asterisco">*</span></label>
                <vue-mask
                  :key="keyCep"
                  mask="00000-000"
                  :raw="false"
                  type="text"
                  v-model.trim="cep"
                  class="form-control"
                  inputmode="numeric"
                  :class="{
                    'is-invalid': this.validation.hasOwnProperty('cep'),
                  }"
                  @input="preencheEndereco"
                  id="cep"
                  @blur="timedOutIsValid('cep')"
                ></vue-mask>
                <span
                  class="invalid-feedback"
                  v-if="this.validation.hasOwnProperty('cep')"
                  >{{ this.validation["cep"].mensagem }}</span
                >
              </div>
              <div class="form-group form--select form-inline-50">
                <label for="cidade"
                  >Cidade<span class="asterisco">*</span></label
                ><select
                  id="cidade"
                  class="form-control"
                  :class="{
                    'is-invalid': this.validation.hasOwnProperty('cidade'),
                  }"
                  @blur="isValid('cidade')"
                  v-model="cidadeInput"
                >
                  <option selected disabled>-</option>
                  <option
                    v-for="(cidade, index) in cidades"
                    :value="cidade.label.split('-')[0].trim()"
                    :key="index"
                    :selected="
                      cidade.label
                        .split('-')[0]
                        .trim()
                        .toLowerCase() == cidadeInput.toLowerCase()
                    "
                  >
                    {{ cidade.label.split("-")[0].trim() }}
                  </option>
                </select>
                <span
                  class="invalid-feedback"
                  v-if="this.validation.hasOwnProperty('cidade')"
                  >{{ this.validation["cidade"].mensagem }}</span
                >
              </div>
            </div>

            <div class="form-group">
              <label for="rua">Rua<span class="asterisco">*</span></label>
              <input
                type="text"
                v-model.trim="rua"
                class="form-control"
                :class="{
                  'is-invalid': this.validation.hasOwnProperty('rua'),
                }"
                maxlength="250"
                id="rua"
                @blur="isValid('rua')"
              />
              <span
                class="invalid-feedback"
                v-if="this.validation.hasOwnProperty('rua')"
                >{{ this.validation["rua"].mensagem }}</span
              >
            </div>
            <div class="form--inline-wrapper">
              <div class="form-group form-inline-25">
                <label for="numero"
                  >Número<span class="asterisco">*</span></label
                >
                <input
                  id="numero"
                  type="text"
                  v-model.trim="numero"
                  class="form-control"
                  inputmode="numeric"
                  maxlength="250"
                  :class="{
                    'is-invalid': this.validation.hasOwnProperty('numero'),
                  }"
                  @blur="isValid('numero')"
                />
                <span
                  class="invalid-feedback"
                  v-if="this.validation.hasOwnProperty('numero')"
                  >{{ this.validation["numero"].mensagem }}</span
                >
              </div>
              <div class="form-group form-inline-75">
                <label for="complemento">Complemento</label
                ><input
                  id="complemento"
                  type="text"
                  class="form-control"
                  maxlength="250"
                  v-model.trim="complemento"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="bairro">Bairro<span class="asterisco">*</span></label
              ><input
                id="bairro"
                type="text"
                class="form-control"
                :class="{
                  'is-invalid': this.validation.hasOwnProperty('bairro'),
                }"
                maxlength="250"
                v-model.trim="bairro"
                @blur="isValid('bairro')"
              />
              <span
                class="invalid-feedback"
                v-if="this.validation.hasOwnProperty('bairro')"
                >{{ this.validation["bairro"].mensagem }}</span
              >
            </div>
            <div class="form-group">
              <label for="observacoes">Observações</label
              ><input
                id="observacoes"
                class="form-control"
                v-model.trim="observacao"
                maxlength="250"
              />
            </div>
          </div>
          <div class="form--col">
            <p class="etapa--title">
              Agendamento
            </p>
            <div class="form--agendamento-wrapper">
              <div class="form-check" v-if="this.showReceberUmaHora">
                <input
                  class="form-check-input"
                  v-model="tipoEntrega"
                  type="radio"
                  id="receber"
                  value="1"
                  name="horario"
                />
                <label class="form-check-label" for="receber">
                  Entrega em <strong>até 1 hora</strong>
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  v-model="tipoEntrega"
                  type="radio"
                  id="agendar"
                  value="0"
                  name="horario"
                />
                <label class="form-check-label" for="agendar">
                  Entrega <strong>agendada</strong>
                </label>
              </div>
            </div>
            <div
              class="form-group form--agendamento form--agendamento__dia"
              v-if="tipoEntrega == '0'"
            >
              <select class="form-control" v-model="dia">
                <option disabled selected value="">DD/MM/AAAA</option>
                <option
                  v-for="dia in this.diasDisponiveis"
                  :key="dia.data"
                  :value="dia"
                  >{{ dia.dia }}</option
                >
              </select>
            </div>
            <div
              class="form-group form--agendamento form--agendamento__horario"
              v-if="tipoEntrega == '0'"
            >
              <select class="form-control" v-model="horaEntrega">
                <option disabled selected value="">Horário</option>
                <option
                  v-for="hora in this.horasDisponiveis"
                  :key="hora"
                  :value="hora"
                  >{{ hora }}</option
                >
              </select>
            </div>
          </div>
        </div>
        <div class="form--etapa" v-if="etapa == 3">
          <div class="form--col form--col__divider">
            <p class="etapa--title">
              Forma de pagamento
            </p>
            <div class="form--warn form--warn__mobile">
              Escolha a melhor forma de pagamento agora e
              <span>pague o revendedor somente na entrega.</span>
              <br />
              A instalação é por nossa conta!
            </div>
            <p class="form--text">Valor Total</p>
            <p class="form--valor">R$ {{ bateriaSelecionada.Valor }}</p>
            <p class="form--text">Forma de pagamento</p>
            <div class="form--pagamento-wrapper">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="pagamento"
                  id="deb"
                  value="1"
                  v-model="tipoPagamento"
                />
                <label class="form-check-label" for="deb">
                  Cartão de <strong>Débito</strong>
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="pagamento"
                  id="cred"
                  value="2"
                  v-model="tipoPagamento"
                />
                <label class="form-check-label" for="cred">
                  Cartão de <strong>Crédito</strong>
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="pagamento"
                  id="cash"
                  value="0"
                  v-model="tipoPagamento"
                />
                <label class="form-check-label" for="cash">
                  <strong>Dinheiro</strong>
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="pagamento"
                  id="pix"
                  value="3"
                  v-model="tipoPagamento"
                />
                <label class="form-check-label" for="pix">
                  <strong>PIX</strong>
                </label>
              </div>
            </div>
            <div
              class="form-group form--select"
              v-if="tipoPagamento == 1 || tipoPagamento == 2"
            >
              <label for="bandeira"
                >Bandeira<span class="asterisco">*</span></label
              ><select id="bandeira" class="form-control" v-model="bandeira">
                <option selected disabled></option>
                <option
                  :value="bandeira"
                  :key="bandeira.Codigo"
                  v-for="bandeira in bandeiras"
                  >{{ bandeira.Nome }}</option
                >
              </select>
            </div>
            <div class="form-group form--select" v-if="tipoPagamento == 2">
              <label for="parcelas"
                >Parcelamento<span class="asterisco">*</span></label
              ><select
                name=""
                id="parcelas"
                class="form-control"
                v-model.trim="parcelas"
              >
                <option
                  v-for="parcela in this.parcelasDisponiveis"
                  :value="parcela"
                  :key="parcela"
                  >{{ parcela }} x sem juros</option
                >
              </select>
            </div>
            <div
              class="form-group"
              v-if="tipoPagamento == 0 && tipoPagamento != ''"
            >
              <label for="troco"
                >Troco para quanto?<span class="asterisco">*</span></label
              >
              <vue-mask
                :key="keyTroco"
                mask="#.##0,00"
                :options="options"
                :raw="false"
                placeholder="R$"
                type="text"
                id="troco"
                class="form-control"
                inputmode="numeric"
                :class="{
                  'is-invalid': this.validation.hasOwnProperty('troco'),
                }"
                v-model="troco"
                @blur="timedOutIsValid('troco')"
                :disabled="semTroco"
              ></vue-mask>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="semTroco"
                  id="semTroco"
                />
                <label class="form-check-label" for="semTroco">
                  Não preciso de troco.
                </label>
              </div>
              <span
                class="invalid-feedback text-center"
                v-if="this.validation.hasOwnProperty('troco')"
                >{{ this.validation["troco"].mensagem }}</span
              >
            </div>
            <div v-if="this.temCupom">
              <label for="cupom">Cupom</label>
              <input
                type="text"
                class="form-control"
                id="cupom"
                v-model.trim="cupom"
                @blur="verificaCupom"
              />
            </div>
          </div>
          <div class="form--col">
            <div class="form--warn">
              Escolha a melhor forma de pagamento agora e
              <span>pague o revendedor somente na entrega.</span>
              <br />
              A instalação é por nossa conta!
            </div>
            <div v-if="tipoPagamento == 1">
              <p class="form--pagamento-resumo">
                Cartão de débito > <strong>{{ bandeira.Nome }}</strong>
              </p>

              <img
                v-if="bandeira.Nome == 'Visa'"
                src="../assets/cartao-visa.png"
                class="form--pagamento-img form--pagamento-img__cartao"
              />
              <img
                v-if="bandeira.Nome == 'Mastercard'"
                src="../assets/cartao-mastercard.png"
                class="form--pagamento-img form--pagamento-img__cartao"
              />
            </div>
            <div v-if="tipoPagamento == 2">
              <p class="form--pagamento-resumo">
                Cartão de crédito > <strong>{{ bandeira.Nome }}</strong>
              </p>
              <p class="form--pagamento-resumo" v-if="parcelas != ''">
                Parcelamento >
                <strong
                  >{{ parcelas }}x R${{ parcelasValor }} (sem juros)</strong
                >
              </p>
              <img
                v-if="bandeira.Nome == 'Visa'"
                src="../assets/cartao-visa.png"
                class="form--pagamento-img form--pagamento-img__cartao"
              />
              <img
                v-if="bandeira.Nome == 'Mastercard'"
                src="../assets/cartao-mastercard.png"
                class="form--pagamento-img form--pagamento-img__cartao"
              />
            </div>
            <div v-if="tipoPagamento == 0 && tipoPagamento != ''">
              <p
                class="form--pagamento-resumo"
                v-if="
                  parseFloat(troco.replace(/\./g, '').replace(',', '.')) > 0
                "
              >
                Dinheiro > <strong>Troco para R${{ troco }}</strong>
              </p>
              <p
                class="form--pagamento-resumo"
                v-if="
                  parseFloat(troco.replace(/\./g, '').replace(',', '.')) == 0
                "
              >
                Dinheiro > <strong>Sem troco</strong>
              </p>
              <img
                src="../assets/pagamento-dinheiro.jpg"
                class="form--pagamento-img"
              />
            </div>
            <div v-if="tipoPagamento == 3">
              <p class="form--pagamento-resumo">
                PIX
              </p>
              <img
                src="../assets/pagamento-pix.png"
                class="form--pagamento-img"
              />
            </div>
          </div>
        </div>
        <div class="form--etapa" v-if="etapa == 4">
          <div class="form--col">
            <p class="etapa--title">
              Revise seu pedido
            </p>
            <p class="etapa--subtitle">Modelo da bateria</p>
            <div class="form--infos-bateria">
              <figure class="infos-bateria--img">
                <!-- <img src="../assets//bateria-placeholder.png" alt="" /> -->
                <img
                  :src="
                    urlBaterias +
                      bateriaSelecionada.Codigo +
                      '/' +
                      bateriaSelecionada.Arquivo
                  "
                  alt=""
                />
              </figure>
              <div>
                <p class="infos-bateria--modelo">
                  {{
                    bateriaSelecionada.Nome.replace(
                      bateriaSelecionada.CodigoHeliar,
                      ""
                    )
                  }}
                </p>
                <p class="infos-bateria--codigo">
                  {{ bateriaSelecionada.CodigoHeliar }}
                </p>
              </div>
            </div>
            <p class="etapa--subtitle">Dados pessoais</p>
            <table class="form--infos">
              <tr>
                <td><span>Nome completo</span></td>
                <td>{{ nome }}</td>
              </tr>
              <tr>
                <td>CPF</td>
                <td>{{ cpf }}</td>
              </tr>
              <tr>
                <td>Telefone</td>
                <td>{{ tel }}</td>
              </tr>
              <tr>
                <td>E-mail</td>
                <td>{{ email }}</td>
              </tr>
            </table>
          </div>
          <div class="form--col form--col__last">
            <p class="etapa--subtitle">Local da entrega</p>
            <table class="form--infos">
              <tr>
                <td><span>CEP</span></td>
                <td>{{ cep }}</td>
              </tr>
              <tr>
                <td>Endereço</td>
                <td>{{ `${rua}, ${numero} - ${bairro}, ${cidade}` }}</td>
              </tr>
              <tr>
                <td>Complemento</td>
                <td>{{ complemento == "" ? "-" : complemento }}</td>
              </tr>
              <tr>
                <td>Observações</td>
                <td>{{ observacao == "" ? "-" : observacao }}</td>
              </tr>
            </table>

            <p class="etapa--subtitle">Agendamento</p>
            <div class="form--infos-agendamento" v-if="tipoEntrega == '0'">
              <p class="agendamento--item">
                <span>Data</span> <span>{{ dia.dia }}</span>
              </p>
              <p class="agendamento--item">
                <span>Hora</span> <span>{{ horaEntrega }}</span>
              </p>
            </div>
            <div class="form--infos-agendamento" v-if="tipoEntrega == '1'">
              <p class="agendamento--item agendamento--item__single">
                <span>Entrega em até uma hora</span>
              </p>
            </div>
            <p class="etapa--subtitle">Pagamento</p>
            <table class="form--infos">
              <tr>
                <td>Valor total</td>
                <td class="info--valor">R${{ bateriaSelecionada.Valor }}</td>
              </tr>
              <tr v-if="cupomDesconto != ''">
                <td>Total desconto</td>
                <td class="info--valor">R${{ totalDesc }}</td>
              </tr>
              <tr>
                <td>Forma de pagamento</td>
                <td>
                  {{
                    tipoPagamento == "1"
                      ? "Cartão de débito"
                      : tipoPagamento == "2"
                      ? "Cartão de crédito"
                      : tipoPagamento == "0"
                      ? "Dinheiro"
                      : "Pix"
                  }}
                </td>
              </tr>
              <tr v-if="tipoPagamento == 1 || tipoPagamento == 2">
                <td>Bandeira</td>
                <td class="info--bandeira" v-if="bandeira.Nome == 'Mastercard'">
                  Mastercard <img src="../assets/cartao-mastercard.png" />
                </td>
                <td class="info--bandeira" v-if="bandeira.Nome == 'Visa'">
                  Visa <img src="../assets/cartao-visa.png" />
                </td>
              </tr>
              <tr v-if="tipoPagamento == 2">
                <td>Parcelamento</td>
                <td>
                  <strong
                    >{{ parcelas }}x R${{ parcelasValor }} (sem juros)</strong
                  >
                </td>
              </tr>
              <tr v-if="tipoPagamento == 0">
                <td>Troco para</td>
                <td
                  v-if="
                    parseFloat(troco.replace(/\./g, '').replace(',', '.')) > 0
                  "
                >
                  <strong>R$ {{ troco }}</strong>
                </td>
                <td
                  v-if="
                    parseFloat(troco.replace(/\./g, '').replace(',', '.')) == 0
                  "
                >
                  <strong>Sem troco</strong>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="form--actions">
          <button
            class="form--anterior btn"
            @click="
              (e) => {
                e.preventDefault();
                this.retrocedeEtapa();
              }
            "
            v-if="etapa > 1"
          >
            <span class="icon icon-chevron-left"></span>Anterior
          </button>

          <button
            class="form--proximo btn"
            @click="
              (e) => {
                e.preventDefault();
                this.avancaEtapa();
              }
            "
            v-if="etapa < 4"
          >
            Próximo<span class="icon icon-chevron-right"></span>
          </button>
          <button
            class="form--proximo form--proximo__concluir btn"
            v-if="etapa == 4"
            :disabled="disableSubmit"
            @click="
              (e) => {
                e.preventDefault();
                this.submit();
              }
            "
          >
            Concluir pedido<span class="icon icon-chevron-right"></span>
          </button>
          <button
            class="form--proximo form--proximo__concluir-mobile btn"
            v-if="etapa == 4"
            :disabled="disableSubmit"
            @click="
              (e) => {
                e.preventDefault();
                this.submit();
              }
            "
          >
            Concluir<span class="icon icon-chevron-right"></span>
          </button>
        </div>
      </form>
    </div>
  </section>
</template>
<script>
/* eslint-disable no-undef */
/* eslint-disable no-useless-escape*/
/* eslint-disable no-console */
import HeliarNav from "../components/HeliarNav.vue";

export default {
  name: "criarPedido",
  components: { HeliarNav },
  data() {
    return {
      cidade: sessionStorage.getItem("cidade"),
      carro: sessionStorage.getItem("carro"),
      codBateria: sessionStorage.getItem("bateria"),
      cidadeSelect: sessionStorage.getItem("cidade"),
      carroSelect: sessionStorage.getItem("carro"),
      trocaOficina: "",
      cidades: [],
      carros: [],
      preenchido: false,
      insertCar: false,
      urlMarcas:
        process.env.NODE_ENV == "production"
          ? "/arquivos/marcas/"
          : "https://www.heliarexpress.com.br/arquivos/marcas/",
      urlBaterias:
        process.env.NODE_ENV == "production"
          ? "/arquivos/baterias/"
          : "https://www.heliarexpress.com.br/arquivos/baterias/",
      etapa: 1,
      keyCpf: 0,
      keyTelefone: 0,
      keyCep: 0,
      keyTroco: 0,
      nome: "",
      cpf: "",
      tel: "",
      email: "",
      cep: "",
      rua: "",
      cidadeInput: sessionStorage.getItem("cidade").split(" - ")[0],
      numero: "",
      complemento: "",
      bairro: "",
      aceitouTermo: true,
      tipoEntrega: "",
      dia: "",
      horaEntrega: "",
      observacao: "",
      tipoPagamento: "",
      bandeira: "",
      parcelas: "",
      troco: "",
      cupom: "",
      cupomTipo: "",
      cupomDesconto: "",
      showCupom: false,
      errorList: {
        preenchimento: [],
        validacao: [],
        outros: [],
      },
      options: {
        reverse: true,
        onChange: (val) => {
          if(val != this.troco) {
            this.troco = val
          }
        },
      },
      validation: {},
      temCupom: "",
      dataAtual: "",
      baterias: [],
      bandeiras: [],
      etapaAtual: 1,
      bateriaSelecionada: {},
      parcelasDisponiveis: 0,
      horario: [],
      feriados: [],
      semTroco: false,
      disableSubmit: false,
    };
  },
  created() {
    this.updateCarCityList();
    this.getBatteries();
  },
  computed: {
    progressWidth: function() {
      var width;
      if (this.etapa == 1) {
        width = "6%";
      } else if (this.etapa == 2) {
        width = "38%";
      } else if (this.etapa == 3) {
        width = "68%";
      } else {
        width = "100%";
      }
      return width;
    },
    sugestCar: function() {
      if (this.carroSelect.length >= 2) {
        var car = this.escapeCharacter(this.carroSelect)
          .split(" ")
          .map((item) => {
            return new RegExp(item, "i");
          });
        var fullCar = new RegExp(
          "^" + this.escapeCharacter(this.carroSelect) + "$",
          "i"
        );
        return this.carros.filter((carro) => {
          return (
            car.reduce((acc, item) => {
              return (
                acc &&
                item.test(carro.marca + " " + carro.modelo + " - " + carro.ano)
              );
            }, true) &&
            !fullCar.test(carro.modelo + " - " + carro.ano) &&
            this.carro != ""
          );
        });
      } else {
        return [];
      }
    },
    sugestCity: function() {
      if (this.cidadeSelect.length >= 2) {
        var city = new RegExp(
          this.escapeCharacter(this.removeAcento(this.cidadeSelect)),
          "i"
        );
        var fullCity = new RegExp(
          "^" + this.escapeCharacter(this.cidadeSelect) + "$",
          "i"
        );
        return this.cidades.filter((item) => {
          return (
            city.test(item.value) &&
            !fullCity.test(item.label) &&
            this.cidade != ""
          );
        });
      } else {
        return [];
      }
    },
    valorParcelado: function() {
      var precisao = Math.pow(10, 2),
        parcelas = this.baterias.map((item) => {
          var valor = item.Valor;
          valor = valor.replace(/\./g, "");
          valor = parseFloat(valor.replace(",", "."));
          valor = (valor * 10) / this.parcelasDisponiveis / 10;
          valor =
            Math.ceil(parseFloat((valor * precisao).toFixed(2))) / precisao;
          valor = valor.toFixed(2).replace(".", ",");
          valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          return valor;
        });
      return parcelas;
    },
    diasDisponiveis: function() {
      if (this.dataAtual != "") {
        var dias = [
            "Domingo",
            "Segunda-feira",
            "Terça-feira",
            "Quarta-feira",
            "Quinta-feira",
            "Sexta-feira",
            "Sábado",
          ],
          date = new Date(this.dataAtual.toISOString()),
          diasEscolhidos = [],
          options = { year: "numeric", month: "2-digit", day: "2-digit" },
          data,
          dataFormatada;
        for (var cont = 0, ajuste = 0; diasEscolhidos.length < 2; cont++) {
          if ((cont + this.diaAtual) % 7 == 0 && cont != 0) {
            ajuste += 7;
          }
          if (
            this.horario[this.diaAtual + cont - ajuste].min != "" &&
            this.horario[this.diaAtual + cont - ajuste].max != ""
          ) {
            if (cont == 0) {
              if (
                parseInt(this.horario[this.diaAtual].max.substring(0, 2)) >=
                this.horaAtual + 2
              ) {
                if (
                  this.verificaFeriado(
                    date.toLocaleDateString("pt-BR", options)
                  )
                ) {
                  date = new Date(this.dataAtual.toISOString());
                  continue;
                }
                data = date.toLocaleDateString("pt-BR", options);
                dataFormatada =
                  data.slice(6) +
                  "/" +
                  data.slice(3, 5) +
                  "/" +
                  data.slice(0, 2);
                diasEscolhidos.push({
                  diaSemana: "Hoje",
                  dia: `${data.slice(0, 2)}/${data.slice(3, 5)}/${data.slice(
                    6
                  )}`,
                  data: dataFormatada,
                });
              }
            } else {
              date.setDate(date.getDate() + cont);
              if (
                this.verificaFeriado(date.toLocaleDateString("pt-BR", options))
              ) {
                date = new Date(this.dataAtual.toISOString());
                continue;
              }
              data = date.toLocaleDateString("pt-BR", options);
              dataFormatada =
                data.slice(6) + "/" + data.slice(3, 5) + "/" + data.slice(0, 2);
              diasEscolhidos.push({
                diaSemana: dias[this.diaAtual + cont - ajuste],
                dia: `${data.slice(0, 2)}/${data.slice(3, 5)}/${data.slice(6)}`,
                data: dataFormatada,
              });
            }
          }
          date = new Date(this.dataAtual.toISOString());
        }
        return diasEscolhidos;
      } else {
        return [];
      }
    },
    horasDisponiveis: function() {
      if (this.horario.length >= 0) {
        var horasList = {
            "0": [],
            "1": [],
            "2": [],
            "3": [],
            "4": [],
            "5": [],
            "6": [],
          },
          index,
          cont;
        for (
          cont = parseInt(this.horario[0].min.substring(0, 2));
          cont <= parseInt(this.horario[0].max.substring(0, 2));
          cont++
        ) {
          if (cont < 10) {
            horasList["0"].push("0" + cont + ":00");
          } else {
            horasList["0"].push(cont + ":00");
          }
        }
        for (
          cont = parseInt(this.horario[1].min.substring(0, 2));
          cont <= parseInt(this.horario[1].max.substring(0, 2));
          cont++
        ) {
          if (cont < 10) {
            horasList["1"].push("0" + cont + ":00");
          } else {
            horasList["1"].push(cont + ":00");
          }
        }
        for (
          cont = parseInt(this.horario[2].min.substring(0, 2));
          cont <= parseInt(this.horario[2].max.substring(0, 2));
          cont++
        ) {
          if (cont < 10) {
            horasList["2"].push("0" + cont + ":00");
          } else {
            horasList["2"].push(cont + ":00");
          }
        }
        for (
          cont = parseInt(this.horario[3].min.substring(0, 2));
          cont <= parseInt(this.horario[3].max.substring(0, 2));
          cont++
        ) {
          if (cont < 10) {
            horasList["3"].push("0" + cont + ":00");
          } else {
            horasList["3"].push(cont + ":00");
          }
        }
        for (
          cont = parseInt(this.horario[4].min.substring(0, 2));
          cont <= parseInt(this.horario[4].max.substring(0, 2));
          cont++
        ) {
          if (cont < 10) {
            horasList["4"].push("0" + cont + ":00");
          } else {
            horasList["4"].push(cont + ":00");
          }
        }
        for (
          cont = parseInt(this.horario[5].min.substring(0, 2));
          cont <= parseInt(this.horario[5].max.substring(0, 2));
          cont++
        ) {
          if (cont < 10) {
            horasList["5"].push("0" + cont + ":00");
          } else {
            horasList["5"].push(cont + ":00");
          }
        }
        for (
          cont = parseInt(this.horario[6].min.substring(0, 2));
          cont <= parseInt(this.horario[6].max.substring(0, 2));
          cont++
        ) {
          if (cont < 10) {
            horasList["6"].push("0" + cont + ":00");
          } else {
            horasList["6"].push(cont + ":00");
          }
        }
        switch (this.dia.diaSemana) {
          case "Domingo":
            return horasList[0];
          case "Segunda-feira":
            return horasList[1];
          case "Terça-feira":
            return horasList[2];
          case "Quarta-feira":
            return horasList[3];
          case "Quinta-feira":
            return horasList[4];
          case "Sexta-feira":
            return horasList[5];
          case "Sábado":
            return horasList[6];
          default:
            if (this.horaAtual < 10) {
              index = horasList[this.diaAtual].indexOf(
                "0" + this.horaAtual + ":00"
              );
            } else {
              index = horasList[this.diaAtual].indexOf(this.horaAtual + ":00");
            }
            return horasList[this.diaAtual].slice(index + 2);
        }
      } else {
        return [];
      }
    },
    horaAtual: function() {
      return this.dataAtual.getHours();
    },
    diaAtual: function() {
      return this.dataAtual.getDay();
    },
    dataEntrega: function() {
      var data,
        dataFormatada,
        date = new Date(this.dataAtual.toISOString()),
        options = { year: "numeric", month: "2-digit", day: "2-digit" };
      if (this.tipoEntrega == "1") {
        data = date.toLocaleDateString("pt-BR", options);
        dataFormatada =
          data.slice(6) + "/" + data.slice(3, 5) + "/" + data.slice(0, 2);
        return dataFormatada;
      } else {
        if (this.dia == "") {
          return "";
        } else {
          return this.dia.data;
        }
      }
    },
    showReceberUmaHora: function() {
      var result;
      if (this.dataAtual != "") {
        result =
          parseInt(this.horario[this.diaAtual].min.substring(0, 2)) <=
            this.horaAtual &&
          parseInt(this.horario[this.diaAtual].max.substring(0, 2)) - 1 >
            this.horaAtual &&
          !this.verificaFeriado(
            this.dataAtual.toLocaleDateString("pt-BR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
          );
      }
      return result;
    },
    parcelasValor: function() {
      var valor;
      var bateria = this.bateriaSelecionada.Valor.replace(/\./g, "");
      var parcelas = parseFloat(this.parcelas);
      var descontado = this.totalDesc.replace(/\./g, "");
      descontado = parseFloat(descontado.replace(",", "."));
      bateria = parseFloat(bateria.replace(",", "."));
      if (this.cupomDesconto == "") {
        valor = (bateria * 10) / parcelas / 10;
      } else {
        valor = (descontado * 10) / parcelas / 10;
      }
      valor = this.arredondar(valor, 2);
      valor = valor.toFixed(2).replace(".", ",");
      return valor.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    totalDesc: function() {
      var bateria = this.bateriaSelecionada.Valor.replace(/\./g, "");
      bateria = parseFloat(bateria.replace(",", "."));
      var valor;
      if (this.cupomTipo == "Porcentagem") {
        valor = (bateria - (bateria * parseFloat(this.cupomDesconto)) / 100.0)
          .toFixed(2)
          .replace(".", ",");
      } else {
        valor = (bateria - parseFloat(this.cupomDesconto))
          .toFixed(2)
          .replace(".", ",");
      }
      return valor.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    trocoCalculado: function() {
      var troco = this.troco.replace(/\./g, "");
      troco = troco.replace(",", ".");
      var valor = this.bateriaSelecionada.Valor.replace(/\./g, "");
      valor = valor.replace(",", ".");
      var totalDesc = this.totalDesc.replace(/\./g, "");
      totalDesc = this.totalDesc.replace(",", ".");
      if (troco) {
        if (
          parseFloat(troco) == parseFloat(valor) ||
          parseFloat(troco) == parseFloat(totalDesc) ||
          parseFloat(troco) == 0
        ) {
          return "0.00";
        } else if (this.cupomDesconto != "") {
          return (parseFloat(troco) - parseFloat(totalDesc)).toFixed(2);
        } else {
          return (parseFloat(troco) - parseFloat(valor)).toFixed(2);
        }
      } else {
        return "";
      }
    },
  },
  watch: {
    tipoPagamento: function() {
      this.bandeira = "";
      this.troco = "";
      this.parcelas = "";
      this.semTroco = false;
      delete this.validation["troco"];
    },
    dia: function() {
      this.horaEntrega = "";
    },
    diasDisponiveis: function(novaLista, velhaLista) {
      if (JSON.stringify(novaLista) != JSON.stringify(velhaLista)) {
        this.dia = "";
      }
    },
    horasDisponiveis: function(novaLista, velhaLista) {
      if (JSON.stringify(novaLista) != JSON.stringify(velhaLista)) {
        this.horaEntrega = "";
      }
    },
    showReceberUmaHora: function(value) {
      if (!value && this.tipoEntrega == "1") {
        this.tipoEntrega = "";
      }
    },
    cidade: function() {
      this.dia = "";
      this.horaEntrega = "";
    },
    carro: function() {
      this.dia = "";
      this.horaEntrega = "";
    },
    semTroco: function(value) {
      if (value) {
        this.troco = "0";
        this.isValid("troco");
      } else {
        this.troco = "";
      }
    },
  },
  methods: {
    updateCarCityList() {
      $.ajax({
        // url: process.env.NODE_ENV=='production'?'./api/PrimeiraEtapa':"http://testeheliarexpress.servicos.ws/api/PrimeiraEtapa",
        url:
          process.env.NODE_ENV == "production"
            ? "./api/PrimeiraEtapa"
            : "https://www2.heliarexpress.com.br/api/PrimeiraEtapa",
        type: "GET",
        success: (response) => {
          this.cidades = response.cidades;
          this.carros = response.carros;
          if (
            sessionStorage.getItem("cidade") != null &&
            sessionStorage.getItem("carro") != null &&
            sessionStorage.getItem("cidade") != "" &&
            sessionStorage.getItem("carro") != ""
          ) {
            this.cidade = sessionStorage.getItem("cidade");
            this.carro = sessionStorage.getItem("carro");
            // this.submit();
          } else {
            this.preenchido = false;
            this.carro = "";
            this.cidade = "";
          }
        },
        error: () => {
          swal
            .fire({
              title: "Ops",
              text: "Algo deu errado e a página será atualizada",
              icon: "warning",
              iconColor: "#1ED760",
              color: "#3C3C3B",
              confirmButtonColor: "#1ED760",
              background: "#EDEDED",
              confirmButtonText: "Ok",
            })
            .then(() => {
              window.location.reload();
            });
        },
      });
    },
    getBatteries() {
      $.ajax({
        // url: process.env.NODE_ENV=='production'?'./api/SegundaEtapa?carro=' + encodeURIComponent(this.carro) + '&cidadeEstado=' + encodeURIComponent(this.cidade):'http://testeheliarexpress.servicos.ws/api/SegundaEtapa?carro=' + encodeURIComponent(this.carro) + '&cidadeEstado=' + encodeURIComponent(this.cidade),
        url:
          process.env.NODE_ENV == "production"
            ? "./api/SegundaEtapa?carro=" +
              encodeURIComponent(this.carro) +
              "&cidadeEstado=" +
              encodeURIComponent(this.cidade)
            : "https://www2.heliarexpress.com.br/api/SegundaEtapa?carro=" +
              encodeURIComponent(this.carro) +
              "&cidadeEstado=" +
              encodeURIComponent(this.cidade),
        type: "GET",
        success: (response) => {
          if (response.Success == false) {
            sessionStorage.setItem("cidade", "");
            sessionStorage.setItem("carro", "");
          } else {
            this.dataAtual = new Date(
              response.data.slice(0, response.data.length - 6)
            );
            setInterval(() => {
              var data = new Date(this.dataAtual.toISOString());
              data.setSeconds(data.getSeconds() + 10);
              this.dataAtual = new Date(data.toISOString());
            }, 10000);
            this.temCupom = response.cupom;
            this.bandeiras = response.bandeiras;
            this.baterias = response.baterias;
            if (this.baterias.length == 0) {
              window.swal
                .fire({
                  title: "Ops",
                  text:
                    "Não foram encontradas baterias para o seu carro na cidade escolhida.",
                  icon: "warning",
                  iconColor: "#1ED760",
                  color: "#3C3C3B",
                  confirmButtonColor: "#1ED760",
                  background: "#EDEDED",
                  confirmButtonText: "Ok",
                })
                .then(() => {
                  sessionStorage.setItem("cidade", "");
                  sessionStorage.setItem("carro", "");
                  sessionStorage.setItem("bateria", "");
                });
              this.bateriaSelecionada = {};
            }
            if (this.codBateria != "") {
              this.selectBateria(
                (this.bateriaSelecionada = this.baterias.find((bateria) => {
                  return bateria.Codigo == this.codBateria;
                }))
              );
            } else {
              if (this.baterias.length == 1) {
                this.selectBateria(this.baterias[0]);
              }
            }
            this.parcelasDisponiveis = response.parcelas;
            this.horario[0] = response.atendimento[6];
            this.horario[1] = response.atendimento[0];
            this.horario[2] = response.atendimento[1];
            this.horario[3] = response.atendimento[2];
            this.horario[4] = response.atendimento[3];
            this.horario[5] = response.atendimento[4];
            this.horario[6] = response.atendimento[5];
            this.feriados = response.feriado;
            // setTimeout(() => {
            //   var scroll = $(".baterias-wrapper").offset().top;
            //   $([document.documentElement, document.body]).animate(
            //     {
            //       scrollTop: scroll,
            //     },
            //     500
            //   );
            // });
          }
        },
        error: () => {
          swal
            .fire({
              title: "Ops",
              text: "Algo deu errado e a página será atualizada",
              icon: "warning",
              iconColor: "#1ED760",
              color: "#3C3C3B",
              confirmButtonColor: "#1ED760",
              background: "#EDEDED",
              confirmButtonText: "Ok",
            })
            .then(() => {
              sessionStorage.setItem("cidade", "");
              sessionStorage.setItem("carro", "");
              window.location.reload();
              // this.$router.push({name:"home"});
            });
        },
      });
    },
    selectCar(carro) {
      this.carroSelect = carro.modelo + " - " + carro.ano;
      this.trocaOficina = carro.trocaOficina;
    },
    selectCity(cidade) {
      this.cidadeSelect = cidade.label;
    },
    avancaEtapa() {
      if (this.etapa === 1) {
        this.isValid("nome");
        this.isValid("cpf");
        this.isValid("tel");
        this.isValid("email");
        if (this.bateriaSelecionada.Codigo == undefined) {
          swal.fire({
            title: "Ops",
            text: "Selecione uma bateria.",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        }
        if (
          Object.entries(this.validation).length == 0 &&
          this.bateriaSelecionada.Codigo != undefined
        ) {
          this.etapa++;
        }
      } else if (this.etapa === 2) {
        this.isValid("cep");
        this.isValid("cidade");
        this.isValid("rua");
        this.isValid("numero");
        this.isValid("bairro");
        if (this.tipoEntrega == "") {
          swal.fire({
            title: "Ops",
            text: "Selecione um tipo de entrega.",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        } else if (this.tipoEntrega == "0" && this.dataEntrega == "") {
          swal.fire({
            title: "Ops",
            text: "Selecione um dia para a entrega.",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        } else if (this.tipoEntrega == "0" && this.horaEntrega == "") {
          swal.fire({
            title: "Ops",
            text: "Selecione um horário para a entrega.",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        }
        if (
          Object.entries(this.validation).length == 0 &&
          (this.tipoEntrega == "1" ||
            (this.tipoEntrega == 0 && this.horaEntrega != "" && this.dia != ""))
        ) {
          this.etapa++;
        }
      } else if (this.etapa === 3) {
        if (this.tipoPagamento == "") {
          swal.fire({
            title: "Ops",
            text: "Selecione um tipo de pagamento.",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        } else if (
          (this.tipoPagamento == "1" || this.tipoPagamento == "2") &&
          this.bandeira == ""
        ) {
          swal.fire({
            title: "Ops",
            text: "Selecione uma bandeira.",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        } else if (this.tipoPagamento == "2" && this.parcelas == "") {
          swal.fire({
            title: "Ops",
            text: "Selecione as parcelas.",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        } else if (this.tipoPagamento == "0") {
          this.isValid("troco");
        }
        if (
          (this.tipoPagamento == "0" &&
            Object.entries(this.validation).length == 0) ||
          this.tipoPagamento == "3" ||
          (this.tipoPagamento == "1" && this.bandeira != "") ||
          (this.tipoPagamento == "2" &&
            this.parcelas != "" &&
            this.bandeira != "")
        )
          this.etapa++;
      }
    },
    retrocedeEtapa() {
      this.etapa--;
      this.validation = {};
    },
    searchCarCity() {
      var validCity = this.validaCidade();
      var validCar = this.validaCarro();
      var error = ""
      if(this.cidadeSelect == "" && this.carroSelect == "") {
        error = "Escolha uma cidade e um carro."
      }
      else if(this.carroSelect == "") {
        error = "Escolha um carro."
      }
      else if(this.cidadeSelect == "") {
        error = "Escolha uma cidade."
      }
      else if(!validCity && !validCar) {
        error = "Escolha uma cidade e um carro válidos."
      }
      else if(!validCar) {
        error = "Escolha um carro válido."
      }
      else if(!validCity) {
        error = "Escolha uma cidade válida."
      }
      if(error == "") {
        this.cidade = this.cidadeSelect;
        this.carro = this.carroSelect;
        this.cidadeInput = this.cidadeSelect.split(" - ")[0]
        this.bateriaSelecionada = {};
        this.codBateria = "";
        this.getBatteries();
        sessionStorage.setItem("cidade", this.cidadeSelect);
        sessionStorage.setItem("carro", this.carroSelect);
        sessionStorage.setItem("bateria", "");
      }
      else {
        swal.fire({
          title: "Ops",
          text: error,
          icon: "warning",
          iconColor: "#1ED760",
          color: "#3C3C3B",
          confirmButtonColor: "#1ED760",
          background: "#EDEDED",
          confirmButtonText: "Ok",
        });
      }
    },
    selectBateria(bateria) {
      this.bateriaSelecionada = bateria;
      sessionStorage.setItem("bateria", bateria.Codigo);
    },
    arredondar(num, precisao) {
      precisao = Math.pow(10, precisao);
      return Math.ceil(parseFloat((num * precisao).toFixed(2))) / precisao;
    },
    validaCidade() {
      var cidReg = new RegExp(
        "^" + this.escapeCharacter(this.cidadeSelect) + "$",
        "i"
      );
      return this.cidades.some((item) => {
        return cidReg.test(item.label);
      });
    },
    validaCarro() {
      var carReg = new RegExp(
        "^" + this.escapeCharacter(this.carroSelect) + "$",
        "i"
      );
      return this.carros.some((item) => {
        return carReg.test(item.modelo + " - " + item.ano);
      });
    },
    escapeCharacter(palavra) {
      return palavra
        .replace(/\\/g, "")
        .replace(/\[/g, "\\[")
        .replace(/\]/g, "\\]")
        .replace(/\^/g, "\\^")
        .replace(/\$/g, "\\$")
        .replace(/\./g, "\\.")
        .replace(/\|/g, "\\|")
        .replace(/\?/g, "\\?")
        .replace(/\*/g, "\\*")
        .replace(/\+/g, "\\+")
        .replace(/\(/g, "\\(")
        .replace(/\)/g, "\\)")
        .replace(/\{/g, "\\{")
        .replace(/\}/g, "\\}");
    },
    removeAcento(palavra) {
      return palavra
        .replace(/á|Á|ã|Ã|â|Â|à|À|ä|Ä/g, "a")
        .replace(/ç|Ç/g, "c")
        .replace(/é|É|ê|Ê|è|È|ë|Ë/g, "e")
        .replace(/í|Í|ì|Ì|ï|Ï|î|Î/g, "i")
        .replace(/ó|Ó|ò|Ò|ö|Ö|õ|Õ/g, "o")
        .replace(/ú|Ú|ù|Ù|ü|Ü|û|Û/g, "u")
        .replace(/Ñ|ñ/g, "n")
        .replace(/ý|Ý/g, "y");
    },
    toggleInsertCar() {
      setTimeout(() => {
        this.insertCar = !this.insertCar;
      }, 200);
    },
    timedOutIsValid(campo) {
      setTimeout(() => {
        this.isValid(campo);
      });
    },
    async isValid(campo) {
      var retorno = { isValid: true, mensagem: "" };
      switch (campo) {
        case "nome":
          if (this.nome == "" || this.nome.split(" ").length < 2) {
            retorno = {
              isValid: false,
              mensagem: "Preencha corretamente o nome.",
            };
          }
          break;
        case "cpf":
          if (this.cpf == "" || this.cpf.length < 14) {
            retorno = {
              isValid: false,
              mensagem: "Preencha corretamente o CPF.",
            };
          } else if (!this.validaCPF(this.cpf)) {
            retorno = { isValid: false, mensagem: "CPF inválido." };
          }
          this.atualizaMasks("cpf")
          break;
        case "tel":
          if (this.tel == "" || this.tel.length < 15) {
            retorno = {
              isValid: false,
              mensagem: "Preencha corretamente o telefone.",
            };
          }
          this.atualizaMasks("tel")
          break;
        case "email":
          var emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
          if (this.email == "") {
            retorno = {
              isValid: false,
              mensagem: "Preencha corretamente o e-mail.",
            };
          } else if (!emailRegex.test(this.email)) {
            retorno = { isValid: false, mensagem: "Email inválido." };
          }
          break;
        case "cep":
          if (this.cep.trim() == "" || this.cep.length < 9) {
            retorno = {
              isValid: false,
              mensagem: "Preencha corretamente o CEP.",
            };
          } else {
            var result = await this.validaCep();
            if (result.hasOwnProperty("erro")) {
              retorno = { isValid: false, mensagem: "CEP inválido." };
            } else if (
              result.localidade.toLowerCase() !=
              this.cidade
                .split("-")[0]
                .trim()
                .toLowerCase()
            ) {
              retorno = {
                isValid: false,
                mensagem:
                  "O CEP de entrega não corresponde com a cidade escolhida.",
              };
            }
          }
          this.atualizaMasks("cep")
          break;
        case "cidade":
          if (this.cidadeInput == "") {
            retorno = {
              isValid: false,
              mensagem: "Preencha corretamente a cidade.",
            };
          } else if (
            this.cidade
              .split("-")[0]
              .trim()
              .toLowerCase() != this.cidadeInput.toLowerCase()
          ) {
            retorno = {
              isValid: false,
              mensagem:
                "A cidade informada no formulário não corresponde com a cidade escolhida na primeira etapa.",
            };
          }
          break;
        case "rua":
          if (this.rua == "") {
            retorno = {
              isValid: false,
              mensagem: "Preencha corretamente a rua.",
            };
          }
          break;
        case "numero":
          if (this.numero == "") {
            retorno = {
              isValid: false,
              mensagem: "Preencha corretamente o número.",
            };
          }
          break;
        case "bairro":
          if (this.bairro == "") {
            retorno = {
              isValid: false,
              mensagem: "Preencha corretamente o bairro.",
            };
          }
          break;
        case "troco":
          if (this.tipoPagamento == "0" && this.troco == "") {
            retorno = { isValid: false, mensagem: "Informe o valor do troco." };
          } else if (this.tipoPagamento == "0" && this.trocoCalculado < 0) {
            retorno = {
              isValid: false,
              mensagem: "Informe um troco maior que o valor da bateria.",
            };
          } else if (
            parseFloat(this.troco.replace(/\./g, "").replace(",", ".")) >
            9999.99
          ) {
            retorno = {
              isValid: false,
              mensagem: "Informe um troco menor que 10.000,00",
            };
          }
          this.atualizaMasks("troco")
      }
      if (retorno.isValid) {
        delete this.validation[campo];
      } else {
        this.validation[campo] = retorno;
      }
      
    },
    atualizaMasks(campo) {
      if(campo == "cpf") {
        this.keyCpf++;
      }
      else if(campo == "tel") {
        this.keyTelefone++;
      }
      else if (campo == "cep") {
        this.keyCep++;
      }
      else if(campo == "troco") {
        this.keyTroco++;
      }
    },
    preencheEndereco() {
      if (this.cep.length == 9) {
        var cep = this.cep.replace("-", "");
        $.getJSON("https://viacep.com.br/ws/" + cep + "/json/", (result) => {
          if (!result.hasOwnProperty("erro")) {
            if (this.errorList.validacao.indexOf("cep") == -1) {
              if (result.logradouro != "" && result.bairro != "") {
                this.rua = result.logradouro;
                this.bairro = result.bairro;
              }
              this.cidadeInput = result.localidade;
              this.isValid("cidade");
              this.isValid("bairro");
              this.isValid("rua");
              this.isValid("cep");
            }
          }
        });
      }
    },
    validaCPF(cpf) {
      cpf = cpf.replace(/\./g, "");
      cpf = cpf.replace("-", "");
      var Soma;
      var Resto;
      Soma = 0;
      if (
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"
      )
        return false;
      for (var i = 1; i <= 9; i++)
        Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(cpf.substring(9, 10))) return false;

      Soma = 0;
      for (i = 1; i <= 10; i++)
        Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(cpf.substring(10, 11))) return false;
      return true;
    },
    validaCep() {
      if (this.cep.length == 9) {
        var cep = this.cep.replace("-", "");
        return new Promise((resolve) => {
          $.getJSON("https://viacep.com.br/ws/" + cep + "/json/", (result) => {
            resolve(result);
          });
        });
      }
    },
    verificaFeriado(dia) {
      if (this.feriados.length > 0) {
        return this.feriados.some((feriado) => {
          return feriado == dia;
        });
      } else {
        return false;
      }
    },
    verificaCupom() {
      $("#submit-pedido").attr("disabled", true);
      this.disableSubmit = true;
      var date = new Date(this.dataAtual.toISOString()),
        options = { year: "numeric", month: "2-digit", day: "2-digit" };
      date.setHours(date.getHours() + 1);
      var verificacao =
        this.tipoEntrega == 0
          ? this.horaEntrega
          : date.toLocaleTimeString("pt-BR", options).slice(11, 16);
      if (
        this.cep.length == 9 &&
        this.uf != "" &&
        this.cidade != "" &&
        this.cupom != "" &&
        this.rua != "" &&
        this.numero != "" &&
        this.bairro != "" &&
        this.tipoEntrega != "" &&
        this.dataEntrega != "" &&
        verificacao != ""
      ) {
        date = new Date(this.dataAtual.toISOString());
        date.setHours(date.getHours() + 1);
        var data = {
          CodigoCarro: this.bateriaSelecionada.CodigoCarro,
          CodigoBateria: this.bateriaSelecionada.Codigo,
          CodigoHeliar: this.bateriaSelecionada.CodigoHeliar,
          Cliente: {
            Nome: this.nome,
            CPF: this.cpf,
            Email: this.email,
            Telefone: this.tel,
            Endereco: {
              Cep: this.cep,
              Endereco: this.rua,
              Numero: this.numero,
              Complemento: this.complemento,
              Cidade: this.cidadeInput,
              Bairro: this.bairro,
              Estado: this.cidade.split("-")[1].trim(),
            },
          },
          Agendamento: {
            TipoEntrega: this.tipoEntrega,
            DataEntrega: this.dataEntrega,
            HorarioEntrega:
              this.tipoEntrega == 0
                ? this.horaEntrega
                : date.toLocaleTimeString("pt-BR", options).slice(12, 17),
            TipoPagamento: this.tipoPagamento,
            Troco: this.trocoCalculado,
            CodigoBandeira: this.bandeira == "" ? "" : this.bandeira.Codigo,
            Parcelas: this.parcelas,
            Cupom: this.cupom,
            Desconto:
              this.cupom != ""
                ? this.bateriaSelecionada.Valor -
                  parseFloat(this.totalDesc.replace(",", "."))
                : "",
            Observacao: this.observacao,
          },
        };
        $.ajax({
          url:
            process.env.NODE_ENV == "production"
              ? "./api/ConsultaCupom"
              : "https://www2.heliarexpress.com.br/api/ConsultaCupom",
          type: "POST",
          data: JSON.stringify(data),
          contentType: "application/json",
          success: (response) => {
            if (response.Success == true) {
              if (response.isValidCupom) {
                this.cupomDesconto = parseFloat(
                  response.ValorCupom.replace(",", ".")
                );
                this.cupomTipo = response.TipoCupom;
                $("#submit-pedido").removeAttr("disabled");
                this.disableSubmit = false;
              } else {
                this.cupomDesconto = "";
                this.cupomTipo = "";
                this.cupom = "";
                swal.fire({
                  title: "Ops",
                  text:
                    "Parece que o código do cupom está incorreto ou já foi usado!",
                  icon: "warning",
                  iconColor: "#1ED760",
                  color: "#3C3C3B",
                  confirmButtonColor: "#1ED760",
                  background: "#EDEDED",
                  confirmButtonText: "Ok",
                });
                $("#submit-pedido").removeAttr("disabled");
                this.disableSubmit = false;
              }
            } else {
              this.cupomDesconto = "";
              this.cupomTipo = "";
              this.cupom = "";
              swal.fire({
                title: "Ops",
                text: "Algo deu errado",
                icon: "warning",
                iconColor: "#1ED760",
                color: "#3C3C3B",
                confirmButtonColor: "#1ED760",
                background: "#EDEDED",
                confirmButtonText: "Ok",
              });
              $("#submit-pedido").removeAttr("disabled");
              this.disableSubmit = false;
            }
          },
          error: () => {
            this.cupomDesconto = "";
            this.cupomTipo = "";
            this.cupom = "";
            swal.fire({
              title: "Ops",
              text: "Algo deu errado, tente novamente ou atualize a página",
              icon: "warning",
              iconColor: "#1ED760",
              color: "#3C3C3B",
              confirmButtonColor: "#1ED760",
              background: "#EDEDED",
              confirmButtonText: "Ok",
            });
            $("#submit-pedido").removeAttr("disabled");
            this.disableSubmit = false;
          },
        });
      } else if (this.cupom != "") {
        this.cupomDesconto = "";
        this.cupomTipo = "";
        this.cupom = "";
        if (
          this.tipoEntrega == "" ||
          (this.tipoEntrega == "0" &&
            (this.horaEntrega == "" || this.dataEntrega == ""))
        ) {
          swal.fire({
            title: "Ops",
            text: "Informe o horário de entrega antes de escolher um cupom",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        } else if (this.cep.length != 9) {
          swal.fire({
            title: "Ops",
            text: "Informe seu CEP antes de escolher um cupom",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        } else if (this.rua == "") {
          swal.fire({
            title: "Ops",
            text: "Informe sua rua antes de escolher um cupom",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        } else if (this.bairro == "") {
          swal.fire({
            title: "Ops",
            text: "Informe seu bairro antes de escolher um cupom",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        } else if (this.numero == "") {
          swal.fire({
            title: "Ops",
            text: "Informe seu numero/complemento antes de escolher um cupom",
            icon: "warning",
            iconColor: "#1ED760",
            color: "#3C3C3B",
            confirmButtonColor: "#1ED760",
            background: "#EDEDED",
            confirmButtonText: "Ok",
          });
        }
        $("#submit-pedido").removeAttr("disabled");
        this.disableSubmit = false;
      } else {
        this.cupomDesconto = "";
        this.cupomTipo = "";
        this.cupom = "";
        $("#submit-pedido").removeAttr("disabled");
        this.disableSubmit = false;
      }
    },
    async submit() {
      $("#submit-pedido").attr("disabled", true);
      this.disableSubmit = true;
      this.errorList.preenchimento = [];
      this.errorList.validacao = [];
      this.errorList.outros = [];
      var result;
      if (this.nome == "" || this.nome.split(" ").length < 2) {
        this.errorList.preenchimento.push("nome");
      }
      this.isValid("nome");
      if (this.cpf == "" || this.cpf.length < 14) {
        this.errorList.preenchimento.push("CPF");
      } else if (!this.validaCPF(this.cpf)) {
        this.errorList.validacao.push("CPF");
      }
      this.isValid("cpf");
      if (this.tel == "" || this.tel.length < 14) {
        this.errorList.preenchimento.push("telefone");
      }
      this.isValid("tel");
      if (this.email == "") {
        this.errorList.preenchimento.push("e-mail");
      } else if (this.email.indexOf("@") == -1) {
        this.errorList.validacao.push("e-mail");
      }
      this.isValid("email");
      if (this.cep.trim() == "" || this.cep.length < 9) {
        this.errorList.preenchimento.push("CEP");
      } else {
        result = await this.validaCep();
        if (result.hasOwnProperty("erro")) {
          this.errorList.validacao.push("CEP");
        } else if (
          result.localidade.toLowerCase() != this.cidadeInput.toLowerCase()
        ) {
          this.errorList.outros.push(
            "O CEP de entrega não corresponde com a cidade escolhida. "
          );
        }
      }
      this.isValid("cep");
      if (
        this.cidade
          .split("-")[0]
          .trim()
          .toLowerCase() != this.cidadeInput.toLowerCase()
      ) {
        this.errorList.outros.push(
          "A cidade informada no formulário não corresponde com a cidade escolhida na primeira etapa. "
        );
      }
      if (this.rua == "") {
        this.errorList.preenchimento.push("rua");
      }
      this.isValid("rua");
      if (this.cidadeInput == "") {
        this.errorList.preenchimento.push("cidade");
      }
      this.isValid("cidade");
      if (this.numero == "") {
        this.errorList.preenchimento.push("número / complemento");
      }
      this.isValid("numero");
      if (this.bairro == "") {
        this.errorList.preenchimento.push("bairro");
      }
      this.isValid("bairro");
      if (this.tipoEntrega == "") {
        this.errorList.preenchimento.push("horário de entrega");
      }
      if (this.tipoEntrega == "0" && this.dia == "") {
        this.errorList.preenchimento.push("dia do agendamento");
      }
      if (this.tipoEntrega == "0" && this.horaEntrega == "") {
        this.errorList.preenchimento.push("hora do agendamento");
      }
      if (this.aceitouTermo == "") {
        this.errorList.outros.push("Aceite os termos e condições de uso. ");
      }
      if (this.tipoPagamento == "") {
        this.errorList.outros.push("Escolha um método de pagamento. ");
      }
      if (
        (this.tipoPagamento == "2" || this.tipoPagamento == "1") &&
        this.bandeira == ""
      ) {
        this.errorList.outros.push("Escolha a bandeira do cartão. ");
      }
      if (this.tipoPagamento == "2" && this.parcelas == "") {
        this.errorList.outros.push("Escolha o número de parcelas. ");
      }
      if (this.tipoPagamento == "0" && this.troco == "") {
        this.errorList.outros.push("Informe o valor do troco. ");
      } else if (this.tipoPagamento == "0" && this.trocoCalculado < 0) {
        this.errorList.outros.push(
          "Informe um troco maior que o valor da bateria. "
        );
      }
      this.isValid("troco");
      if (
        this.errorList.preenchimento.length > 0 ||
        this.errorList.validacao.length > 0 ||
        this.errorList.outros.length > 0
      ) {
        var errorMessage = "";
        if (this.errorList.preenchimento.length > 0) {
          if (
            this.errorList.preenchimento[0] == "data de nascimento" ||
            this.errorList.preenchimento[0] == "rua" ||
            this.errorList.preenchimento[0] == "hora do agendamento" ||
            this.errorList.preenchimento[0] == "razão social" ||
            this.errorList.preenchimento[0] == "inscrição estadual"
          ) {
            errorMessage = "Preencha corretamente a sua";
          } else {
            errorMessage += "Preencha corretamente o seu";
          }
          this.errorList.preenchimento.forEach((item, index) => {
            if (index == this.errorList.preenchimento.length - 1) {
              errorMessage += " " + item + ". ";
            } else if (index == this.errorList.preenchimento.length - 2) {
              errorMessage += " " + item + " e";
            } else {
              errorMessage += " " + item + ",";
            }
          });
        }
        if (this.errorList.validacao.length > 0) {
          this.errorList.validacao.forEach((item, index) => {
            if (index == this.errorList.validacao.length - 1) {
              errorMessage += " " + item + " ";
            } else if (index == this.errorList.validacao.length - 2) {
              errorMessage += " " + item + " e";
            } else {
              errorMessage += " " + item + ",";
            }
          });
          if (this.errorList.validacao.length == 1) {
            if (this.errorList.validacao[0] == "data de nascimento") {
              errorMessage += "inválida. ";
            } else {
              errorMessage += "inválido. ";
            }
          } else {
            errorMessage += "inválidos. ";
          }
        }
        if (this.errorList.outros.length > 0) {
          this.errorList.outros.forEach((item) => {
            errorMessage += item;
          });
        }
        swal.fire({
          title: "Ops",
          text: errorMessage,
          icon: "warning",
          iconColor: "#1ED760",
          color: "#3C3C3B",
          confirmButtonColor: "#1ED760",
          background: "#EDEDED",
          confirmButtonText: "Ok",
        });
        $("#submit-pedido").removeAttr("disabled");
        this.disableSubmit = false;
      } else {
        var date = new Date(this.dataAtual.toISOString());
        date.setHours(date.getHours() + 1);
        var options = { year: "numeric", month: "2-digit", day: "2-digit" };
        var data = {
          CodigoCarro: this.bateriaSelecionada.CodigoCarro,
          CodigoBateria: this.bateriaSelecionada.Codigo,
          CodigoHeliar: this.bateriaSelecionada.CodigoHeliar,
          Cliente: {
            Nome: this.nome,
            CPF: this.cpf,
            Email: this.email,
            Telefone: this.tel,
            Endereco: {
              Cep: this.cep,
              Endereco: this.rua,
              Numero: this.numero,
              Complemento: this.complemento,
              Cidade: this.cidadeInput,
              Bairro: this.bairro,
              Estado: this.cidade.split("-")[1].trim(),
            },
          },
          Agendamento: {
            TipoEntrega: this.tipoEntrega,
            DataEntrega: this.dataEntrega,
            HorarioEntrega:
              this.tipoEntrega == 0
                ? this.horaEntrega
                : date.toLocaleTimeString("pt-BR", options).slice(12, 17),
            TipoPagamento: this.tipoPagamento,
            Troco: this.trocoCalculado,
            CodigoBandeira: this.bandeira == "" ? "" : this.bandeira.Codigo,
            Parcelas: this.parcelas,
            Cupom: this.cupom,
            Desconto:
              this.cupom != ""
                ? this.arredondar(parseFloat(this.bateriaSelecionada.Valor.replace(/\./g, "").replace(",", ".")) -
                  parseFloat(this.totalDesc.replace(/\./g, "").replace(",", ".")), 2)
                : "",
            Observacao: this.observacao,
          },
        };
        $.ajax({
          url:
            process.env.NODE_ENV == "production"
              ? "./api/Pedido"
              : "https://www2.heliarexpress.com.br/api/Pedido",
          type: "POST",
          data: JSON.stringify(data),
          contentType: "application/json",
          success: (response) => {
            if (response.success == true) {
              sessionStorage.setItem("cidade", "");
              sessionStorage.setItem("carro", "");
              sessionStorage.setItem("bateria", "");
              this.$router.push({
                name: "pedidoEfetuado",
                params: {
                  email: this.email,
                },
              });
              console.log(response.pedido);
            } else {
              swal.fire({
                title: "Ops",
                text:
                  response.mensagem != undefined && response.mensagem != ""
                    ? response.mensagem
                    : "Algo deu errado",
                icon: "warning",
                iconColor: "#1ED760",
                color: "#3C3C3B",
                confirmButtonColor: "#1ED760",
                background: "#EDEDED",
                confirmButtonText: "Ok",
              });
            }
            $("#submit-pedido").removeAttr("disabled");
            this.disableSubmit = false;
          },
          error: () => {
            swal.fire({
              title: "Ops",
              text: "Algo deu errado, tente novamente ou atualize a página",
              icon: "warning",
              iconColor: "#1ED760",
              color: "#3C3C3B",
              confirmButtonColor: "#1ED760",
              background: "#EDEDED",
              confirmButtonText: "Ok",
            });
            $("#submit-pedido").removeAttr("disabled");
            this.disableSubmit = false;
          },
        });
      }
    },
  },
};
</script>
<style lang="scss">
.criar-pedido {
  color: $cinza-escuro;
  margin-top: 53px;
  margin-bottom: 83px;
  &--progresso {
    margin-top: 48px;
    background-color: #d9d9d9;
    border-radius: 10px;
    height: 8px;
    position: relative;
    overflow: visible;
    .progress-bar {
      background-color: $verde-heliar;
      border-radius: 10px;
      transition: width 0.5s;
    }
    .progresso {
      &--itens {
        position: absolute;
        top: 15px;
        z-index: 1;
        display: flex;
        justify-content: space-between;
        width: 100%;
      }
      &--item {
        font-size: 18px;
        margin-bottom: 0;
        &__active {
          font-weight: 700;
        }
      }
    }
  }
  &--form {
    background-color: $second-bg-color;
    padding: 28px;
    border-radius: 10px;
    margin-top: 83px;
    .form {
      &--citycar-selection {
        display: flex;
        flex-direction: column;
        position: relative;
        flex-grow: 1;
        margin-bottom: 14px;
        .citycar-selection {
          &--input {
            position: relative;
            &::after {
              content: "\79";
              font-family: "heliar-express" !important;
              font-style: normal !important;
              font-weight: normal !important;
              font-variant: normal !important;
              text-transform: none !important;
              speak: none;
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
              position: absolute;
              top: 50%;
              right: 20px;
              font-size: 10px;
              line-height: 0;
            }
            .form-control {
              height: 54px;
              padding-left: 45px;
              padding-right: 45px;
              background: #fff;
              margin: 0 auto;
              width: 100%;
              border-radius: 5px;
              border: 1px solid #d9d9d9;
              font-size: 15px;
              padding-bottom: 0;
              padding-top: 0;
              &::placeholder {
                color: $cinza-escuro;
              }
              &:focus {
                box-shadow: none;
                color: inherit;
              }
            }
          }
          &--img {
            position: absolute;
            top: 18px;
            left: 14px;
            font-size: 19px;
            line-height: 0;
            color: $verde-heliar;
            max-width: 35px;
          }
          &--sugestions {
            background-color: $white;
            border-radius: 5px;
            border: 1px solid #d9d9d9;
            overflow: hidden;
            margin-top: 1px;
            padding: 16px;
            position: absolute;
            top: 100%;
            width: 100%;
            &__car {
              max-height: 345px;
              overflow: auto;
              z-index: 2;
              &::-webkit-scrollbar {
                width: 18px;
              }
              &::-webkit-scrollbar-thumb {
                background-color: $cinza-escuro;
                border: 6px solid transparent;
                border-radius: 70px;
                background-clip: padding-box;
              }
            }
            &__city {
              max-height: 250px;
              overflow: auto;
              z-index: 3;
              &::-webkit-scrollbar {
                width: 18px;
              }
              &::-webkit-scrollbar-thumb {
                background-color: $cinza-escuro;
                border: 6px solid transparent;
                border-radius: 70px;
                background-clip: padding-box;
              }
            }
          }
          &--sugestion {
            position: relative;
            background-color: $white;
            min-height: 15px;
            padding-left: 50px;
            color: $cinza-escuro;
            cursor: pointer;
            span {
              font-size: 22px;
            }
            p {
              font-size: 16px;
              margin: 0;
            }
            &:not(:first-child) {
              border-top: 1px solid $cinza-medio;
              margin-top: 20px;
              padding-top: 20px;
              .citycar-selection {
                &--img {
                  top: 20px;
                }
              }
            }
            .citycar-selection {
              &--img {
                top: 0;
                left: 0;
                width: 25px;
              }
            }
            &__car {
              .citycar-selection {
                &--img {
                  top: 10px;
                  left: 0;
                  width: 50px;
                }
              }
              span {
                font-size: 22px;
                color: $cinza-escuro;
                opacity: 0.7;
              }
            }
            &__city {
            }
          }
          &--warn {
            color: $cinza-escuro;
            font-weight: bold;
            text-align: center;
            font-size: 14px;
          }
        }
      }
      &--infos {
        width: 100%;
        font-size: 15px;
        margin-bottom: 35px;
        table-layout: fixed;
        .info {
          &--valor {
            font-weight: 700;
            color: $verde-heliar;
          }
          &--bandeira {
            position: relative;
            img {
              width: 24px;
              height: auto;
              display: inline-block;
              margin-left: 7px;
            }
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
        tr {
          border-bottom: 1px solid #d9d9d9;
          &:last-child {
            border-bottom: none;
          }
          td {
            padding-top: 10px;
            padding-bottom: 10px;
            line-height: normal;
            font-style: italic;
            word-wrap: break-word;
            &:first-child {
              padding-right: 28px;
              font-weight: 700;
              color: #8c8c8c;
              white-space: nowrap;
              font-style: normal;
            }
          }
        }
      }
      &--infos-bateria {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        .infos-bateria {
          &--img {
            width: 136px;
            margin-bottom: 0;
            margin-right: 14px;
            img {
              max-width: 100%;
              height: auto;
            }
          }
          &--wrapper {
            display: flex;
          }
          &--modelo {
            font-size: 15px;
            font-style: italic;
            margin-bottom: 0;
            line-height: normal;
          }
          &--codigo {
            font-size: 22px;
            font-style: italic;
            font-weight: 700;
            margin-bottom: 0;
            line-height: normal;
          }
        }
      }
      &--infos-agendamento {
        display: flex;
        font-size: 15px;
        .agendamento {
          &--item {
            border-right: 1px solid #d9d9d9;
            margin-bottom: 42px;
            &:first-child {
              padding-right: 28px;
            }
            &:last-child {
              border: none;
              padding-left: 28px;
            }
            span {
              &:first-child {
                font-weight: 600;
                color: #8c8c8c;
                padding-right: 16px;
              }
              &:last-child {
                font-style: italic;
              }
            }
            &__single {
              &:first-child {
                padding-right: 0;
                padding-left: 0;
              }
              span {
                &:first-child {
                  padding-right: 0;
                  padding-left: 0;
                }
              }
            }
          }
        }
      }
      &--divider {
        color: #8c8c8c;
        font-size: 15px;
        text-align: center;
        position: relative;
        margin-top: 24px;
        margin-bottom: 12px;
        span {
          background-color: $second-bg-color;
          position: relative;
          z-index: 1;
          display: inline-block;
          padding-left: 14px;
          padding-right: 14px;
        }
        &::after {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          height: 1px;
          background-color: #d9d9d9;
          display: block;
          width: 100%;
        }
      }
      &--bateria {
        background-color: $white;
        border: 1px solid #8c8c8c;
        border-radius: 5px;
        padding: 20px 48px 0px 0px;
        display: flex;
        position: relative;
        margin-bottom: 12px;
        align-items: center;
        cursor: pointer;
        .bateria {
          &--modelo {
            font-size: 15px;
            font-style: italic;
            margin-bottom: 10px;
          }
          &--img {
            width: 165px;
            margin-bottom: 0;
            flex-shrink: 0;
            img {
              max-width: 100%;
              height: auto;
            }
          }
          &--select {
            position: absolute;
            top: 50%;
            right: 20px;
          }
          &--preco {
            margin-bottom: 0;
            display: flex;
            align-items: center;
            &__avista {
              color: $verde-heliar;
              font-weight: 900;
              font-style: italic;
              font-size: 25px;
              margin-right: 11px;
              white-space: nowrap;
            }
            &__aprazo {
              color: #acacac;
              font-size: 12px;
              strong {
                font-weight: 600;
              }
            }
          }
        }
      }
      &--proximo,
      &--anterior {
        font-size: 16px;
        padding: 17px 27px;
        font-weight: 700;
        border-radius: 5px;
        .icon {
          font-size: 11px;
          line-height: 0;
          display: inline-block;
        }
      }
      &--proximo {
        color: $cinza-escuro;
        background-color: $verde-heliar;
        margin-left: auto;
        .icon {
          margin-left: 7px;
        }
        &__concluir {
          &:disabled {
            cursor: default;
          }
        }
        &__concluir-mobile {
          display: none;
          &:disabled {
            cursor: default;
          }
        }
      }
      &--anterior {
        color: $white;
        background-color: #8c8c8c;
        .icon {
          margin-right: 7px;
        }
      }
      &--actions {
        display: flex;
        justify-content: space-between;
      }
      &--etapa {
        display: flex;
        .etapa {
          &--title {
            font-size: 22px;
            font-weight: 700;
            font-style: italic;
            margin-bottom: 41px;
            text-transform: uppercase;
          }
          &--subtitle {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 14px;
            text-transform: uppercase;
          }
        }
      }
      &--col {
        flex-basis: 50%;
        max-width: 50%;
        padding-bottom: 28px;
        &__last {
          padding-top: calc(33px + 41px);
        }
        &:first-child {
          padding-right: 40px;
          border-right: 1px solid #d9d9d9;
        }
        &:last-child {
          padding-left: 40px;
        }
        .form-group {
          margin-bottom: 14px;
        }
        .form-control {
          border-radius: 5px;
          border: 1px solid #8c8c8c;
          font-size: 18px;
          height: 55px;
          color: $cinza-escuro;
        }
        label {
          font-size: 15px;
          position: relative;
          .asterisco {
            color: #ff8f5f;
            position: absolute;
            right: -8px;
            top: -2px;
          }
        }
      }
      &--inline-wrapper {
        display: flex;
        .form-inline {
          &-25,
          &-50,
          &-75 {
            margin-right: 14px;
            &:last-child {
              margin-right: 0;
            }
          }
          &-25 {
            flex-basis: 25%;
          }
          &-50 {
            flex-basis: 50%;
          }
          &-75 {
            flex-basis: 75%;
          }
        }
      }
      &--agendamento-wrapper {
        display: flex;
        margin-bottom: 28px;
        .form-check {
          flex-basis: 50%;
          font-size: 15px;
        }
      }
      &--pagamento-wrapper {
        display: flex;
        margin-bottom: 42px;
        .form-check {
          font-size: 15px;
          flex-grow: 1;
          flex-shrink: 1;
        }
      }
      &--agendamento {
        appearance: none;
        position: relative;
        margin-bottom: 14px;
        &:last-child {
          margin-bottom: 0;
        }
        select {
          appearance: none;
          padding-left: 42px;
          padding-right: 42px;
        }
        &::before,
        &::after {
          position: absolute;
          display: inline-block;
          font-family: "heliar-express" !important;
          font-style: normal !important;
          font-weight: normal !important;
          font-variant: normal !important;
          text-transform: none !important;
          speak: none;
          line-height: 0;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          top: 50%;
        }
        &::after {
          content: "\79";
          right: 14px;
          font-size: 11px;
        }
        &::before {
          left: 14px;
          font-size: 22px;
          color: $verde-heliar;
        }
        &__dia {
          &::before {
            content: "\71";
          }
        }
        &__horario {
          &::before {
            content: "\7a";
          }
        }
      }
      &--warn {
        text-align: center;
        font-size: 15px;
        padding: 15px 21px;
        background-color: #ff8f5f1f;
        border-radius: 10px;
        border: 1px solid #ff8f5f;
        font-weight: 600;
        line-height: normal;
        width: 402px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 56px;
        &__mobile {
          display: none;
        }
        span {
          text-transform: uppercase;
        }
      }
      &--pagamento-resumo {
        text-align: center;
        font-size: 15px;
        margin-bottom: 14px;
        font-style: italic;
      }
      &--pagamento-img {
        max-width: 100%;
        height: auto;
        width: 320px;
        display: block;
        margin: 0 auto 86px auto;
        &__cartao {
          width: 235px;
        }
      }
      &--select {
        position: relative;
        select {
          appearance: none;
          padding-right: 42px;
          &.is-invalid {
            background-image: none;
          }
        }
        &::after {
          content: "\79";
          right: 14px;
          font-size: 11px;
          position: absolute;
          display: inline-block;
          font-family: "heliar-express" !important;
          font-style: normal !important;
          font-weight: normal !important;
          font-variant: normal !important;
          text-transform: none !important;
          speak: none;
          line-height: 0;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          top: 60px;
        }
      }
      &--cidade-carro {
        font-size: 15px;
        margin-bottom: 14px;
      }
      &--search {
        background-color: $cinza-escuro;
        color: $white;
        font-size: 16px;
        font-weight: 700;
        width: 100%;
        text-align: center;
        padding-top: 20px;
        padding-bottom: 20px;
        line-height: normal;
      }
      &--valor {
        color: $verde-heliar;
        font-size: 40px;
        font-weight: 900;
        font-style: italic;
        margin-bottom: 40px;
        line-height: normal;
      }
      &--text {
        font-weight: 700;
        font-size: 15px;
        margin-bottom: 20px;
      }
    }
  }
}
@media (max-width: 1600px) {
  .criar-pedido {
    &--form {
      .form {
        &--col {
          &:first-child {
            padding-right: 30px;
          }
          &:last-child {
            padding-left: 30px;
          }
        }
        &--bateria {
          .bateria {
            &--img {
              width: 115px;
            }
            &--preco {
              &__avista {
                font-size: 22px;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1200px) {
  .criar-pedido {
    &--form {
      .form {
        &--col {
          &:first-child {
            padding-right: 20px;
          }
          &:last-child {
            padding-left: 20px;
          }
        }
        &--bateria {
          padding-left: 0;
          .bateria {
            &--img {
              width: 100px;
            }
            &--preco {
              &__avista {
                font-size: 18px;
              }
            }
          }
        }
        &--warn {
          width: 100%;
        }
        &--pagamento-wrapper {
          flex-wrap: wrap;
          .form-check {
            flex-basis: 50%;
          }
        }
        &--infos {
          tr {
            td {
              &:first-child {
                padding-right: 20px;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .criar-pedido {
    &--progresso {
      height: 14px;
      .progress-bar {
        position: relative;
        overflow: visible;
        &::after {
          content: "";
          position: absolute;
          right: 0;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background-color: $verde-heliar;
          display: inline-block;
        }
      }
      .progresso {
        &--itens {
          display: none;
        }
      }
    }
    &--form {
      border-radius: 30px;
      margin-top: 56px;
      padding: 35px;
      .form {
        &--etapa {
          flex-wrap: wrap;
          .etapa {
            &--title {
              font-size: 37px;
              margin-bottom: 28px;
              line-height: normal;
            }
            &--subtitle {
              font-size: 21px;
              margin-bottom: 28px;
              line-height: normal;
            }
          }
        }
        &--col {
          flex-basis: 100%;
          max-width: 100%;
          margin-bottom: 106px;
          &:first-child {
            border: none;
            padding: 0;
          }
          &:last-child {
            padding: 0;
          }
          label {
            font-size: 21px;
            .asterisco {
              right: -14px;
            }
          }
          .form-control {
            border-radius: 20px;
            font-size: 24px;
            height: 86px;
          }
          .form-group {
            margin-bottom: 28px;
          }
          &__divider {
            &:first-child {
              border-bottom: 1px solid #d9d9d9;
              margin-bottom: 53px;
              padding-bottom: 53px;
            }
          }
        }
        &--cidade-carro {
          margin-bottom: 28px;
          font-size: 21px;
        }
        &--bateria {
          border-radius: 30px;
          padding: 35px 70px 0 0;
          margin-bottom: 28px;
          .bateria {
            &--img {
              width: 191px;
            }
            &--modelo {
              font-size: 21px;
              margin-bottom: 10px;
              line-height: normal;
            }
            &--preco {
              &__avista {
                font-size: 29px;
                margin-right: 9px;
              }
              &__aprazo {
                font-size: 15px;
              }
            }
            &--select {
              width: 35px;
              height: 35px;
              right: 25px;
              transform: translateY(-50%);
            }
          }
        }
        &--divider {
          font-size: 21px;
          margin-bottom: 56px;
        }
        &--search {
          border-radius: 20px;
          font-size: 27px;
          padding-top: 27px;
          padding-bottom: 27px;
        }
        &--proximo,
        &--anterior {
          font-size: 27px;
          border-radius: 20px;
          padding: 27px 78px 27px 78px;
          .icon {
            font-size: 15px;
          }
        }
        &--proximo {
          &__concluir {
            display: none;
          }
          &__concluir-mobile {
            display: inline-block;
          }
        }
        &--inline-wrapper {
          flex-wrap: wrap;
          .form-inline-50,
          .form-inline-25,
          .form-inline-75 {
            flex-basis: 100%;
            max-width: 100%;
            margin-right: 0;
          }
        }
        &--select {
          &:after {
            font-size: 20px;
            top: 80px;
            right: 21px;
          }
        }
        &--agendamento-wrapper {
          margin-bottom: 57px;
          .form-check {
            padding-left: 45px;
          }
          .form-check-input {
            width: 28px;
            height: 28px;
            margin-left: -45px;
            margin-top: 3px;
          }
        }
        &--infos {
          font-size: 21px;
          margin-bottom: 56px;
          .info {
            &--bandeira {
              padding-right: calc(35px + 14px);
              img {
                width: 35px;
                position: absolute;
                right: 14px;
              }
            }
          }
          tr {
            td {
              position: relative;
              padding-top: 22px;
              padding-bottom: 22px;
              &:first-child {
                padding-right: 62px;
              }
            }
          }
        }
        &--infos-bateria {
          margin-bottom: 42px;
          .infos-bateria {
            &--img {
              width: 212px;
            }
            &--modelo {
              font-size: 21px;
              margin-bottom: 12px;
            }
            &--codigo {
              font-size: 29px;
            }
          }
        }
        &--infos-agendamento {
          font-size: 21px;
          .agendamento {
            &--item {
              flex-basis: 50%;
              margin-bottom: 56px;
              span {
                &:first-child {
                  padding-right: 24px;
                }
              }
              &:last-child {
                text-align: center;
              }
              &__single {
                flex-basis: 100%;
                &:last-child,
                &:first-child {
                  text-align: left;
                }
              }
            }
          }
        }
        &--warn {
          display: none;
          font-size: 21px;
          padding: 21px 42px;
          margin-bottom: 29px;
          &__mobile {
            display: block;
          }
        }
        &--text {
          font-size: 21px;
          margin-bottom: 28px;
        }
        &--valor {
          font-size: 58px;
          margin-bottom: 53px;
        }
        &--pagamento-wrapper {
          margin-bottom: calc(56px - 28px);
          .form-check {
            padding-left: 45px;
            margin-bottom: 28px;
          }
          .form-check-input {
            width: 28px;
            height: 28px;
            margin-left: -45px;
            margin-top: 3px;
          }
        }
        &--pagamento-resumo {
          font-size: 21px;
          margin-bottom: 7px;
          &:last-child {
            margin-bottom: 28px;
          }
        }
        &--pagamento-img {
          width: 430px;
          margin-bottom: 0;
          &__cartao {
            width: 323px;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .criar-pedido {
    &--form {
      .form {
        &--infos {
          font-size: 18px;
          tr {
            td {
              &:first-child {
                padding-right: 45px;
              }
            }
          }
        }
        &--infos-agendamento {
          font-size: 18px;
          .agendamento {
            &--item {
              span {
                &:first-child {
                  padding-right: 20px;
                }
              }
            }
          }
        }
        &--anterior,
        &--proximo {
          font-size: 20px;
          padding: 27px 50px;
          .icon {
            font-size: 13px;
          }
        }
        &--anterior {
          .icon {
            margin-right: 5px;
          }
        }
        &--proximo {
          .icon {
            margin-left: 5px;
          }
        }
        &--pagamento-wrapper {
          .form-check {
            padding-left: 35px;
          }
          .form-check-input {
            width: 25px;
            height: 25px;
            margin-left: -35px;
          }
        }
        &--agendamento-wrapper {
          .form-check {
            padding-left: 35px;
          }
          .form-check-input {
            width: 25px;
            height: 25px;
            margin-left: -35px;
          }
        }
        &--bateria {
          padding-right: 50px;
          .bateria {
            &--img {
              width: 150px;
            }
            &--modelo {
              font-size: 18px;
            }
            &--preco {
              &__avista {
                font-size: 24px;
              }
              &__aprazo {
                font-size: 14px;
              }
            }
            &--select {
              width: 25px;
              height: 25px;
              right: 20px;
            }
          }
        }
        &--search {
          font-size: 20px;
          padding-top: 27px;
          padding-bottom: 27px;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .criar-pedido {
    &--form {
      padding: 25px;
      .form {
        &--bateria {
          padding-right: 35px;
          align-items: flex-start;
          .bateria {
            &--img {
              width: 100px;
              flex-shrink: 1;
            }
            &--modelo {
              font-size: 14px;
            }
            &--preco {
              flex-wrap: wrap;
              &__avista {
                font-size: 18px;
              }
              &__aprazo {
                margin-bottom: 10px;
              }
            }
            &--select {
              width: 15px;
              height: 15px;
              right: 15px;
            }
          }
        }
        &--col {
          .etapa {
            &--title {
              font-size: 26px;
            }
            &--subtitle {
            }
          }
          .form-control {
            height: 70px;
            font-size: 18px;
          }
        }
        &--select {
          &:after {
            font-size: 16px;
            top: 75px;
          }
        }
        &--cidade-carro {
          font-size: 16px;
        }
        &--divider {
          font-size: 16px;
        }
        &--anterior,
        &--proximo {
          flex-basis: 50%;
          font-size: 16px;
          padding: 20px 0;
          .icon {
            font-size: 10px;
          }
        }
        &--proximo {
          margin-left: 25px;
          &:first-child {
            margin-left: auto;
          }
        }
        &--agendamento-wrapper {
          .form-check {
            padding-left: 25px;
          }
          .form-check-input {
            width: 15px;
            height: 15px;
            margin-left: -20px;
          }
          .form-check-label {
            font-size: 16px;
          }
        }
        &--warn {
          font-size: 16px;
          padding: 15px 30px;
        }
        &--valor {
          font-size: 38px;
        }
        &--pagamento-wrapper {
          .form-check {
            padding-left: 25px;
          }
          .form-check-input {
            width: 15px;
            height: 15px;
            margin-left: -20px;
          }
          .form-check-label {
            font-size: 16px;
          }
        }
        &--infos {
          max-width: 100%;
          font-size: 16px;
          tr {
            td {
              &:first-child {
                white-space: normal;
                padding-right: 20px;
              }
              &:last-child {
                font-size: 14px;
              }
            }
          }
        }
        &--infos-agendamento {
          font-size: 16px;
          .agendamento {
            &--item {
              &:first-child {
                padding-right: 10px;
              }
              &:last-child {
                padding-left: 10px;
              }
              span {
                &:first-child {
                  padding-right: 5px;
                }
              }
              &__single {
                &:first-child,
                &:last-child {
                  padding-left: 0;
                  padding-right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
